module.exports = __webpack_public_path__ + "static/media/shutterstock_451539856-reduced-50.0a53c244.jpg";